var $ = require('jquery');
var _ = require('../core/lodash');
var isFormEleReg = /^(input|select|textarea)$/;
/*
var state = {
    a:'',
    arr:[{
        b:''
    }],
    check:['a']
};
*/

/*
as-model,as-text,as-html渲染state或构建state的key path，例：a|arr[0].b|check
*/
var ACCESS_MODEL = 'as-model';//随表单控件类型不同而不同。
var ACCESS_TEXT = 'as-text';//更新元素的textContent
var ACCESS_HTML = 'as-html';//更新元素的innerHTML

var ACCESS_TYPE = 'as-type';//构建state的转换数据格式，例：boolean|array|number|string，一般不需要设置

/**
 * 从模版数据渲染第一个元素后代的值
 * @param options
 */
$.fn.trfRenderAccessState  = function (options) {
    options = $.extend(true,{
        //需要渲染的模版数据
        state:{},
        //渲染值，对应[access-render]
        Render:{
            html:function ($el,value) {
                $el.html(value);
            },
            text:function ($el,value) {
                $el.text(value);
            },
            model:function ($el, value) {
                var valueType = $.type(value);
                var type = ($el.attr('type')||'').toLowerCase();

                if(type ==='checkbox' || type ==='radio'){
                    if(valueType ==='array'){
                        value.some(function (val) {
                            if($el.is('[value="' + val + '"]')){
                                $el.prop('checked',true);
                                return true;
                            }
                        })|| $el.prop('checked',false);
                    }else{
                        $el.prop('checked',$el.is('[value="' + value + '"]'));
                    }
                }else{
                    $el.val(value);
                }
            }
        }
    },options);
    var state = options.state;
    var Render = options.Render;
    var $scope = this.first();
    //表单控件
    $scope.find('[' +ACCESS_MODEL+']').each(function () {
        var tagName = this.tagName.toLowerCase();
        //非表单元素提前返回
        if(!isFormEleReg.test(tagName)) return;

        var $this = $(this);
        var propKey = $this.attr(ACCESS_MODEL);
        var value = _.get(state,propKey);
        if(value != null){
            Render.model($this,value);
        }

    });
    //元素的textContent
    $scope.find('[' +ACCESS_TEXT+']').each(function () {
        var $this = $(this);
        var propKey = $this.attr(ACCESS_TEXT);
        var value = _.get(state,propKey);

        if(value != null){
            Render.text($this,value);
        }
    });
    //元素的innerHTML
    $scope.find('[' +ACCESS_HTML+']').each(function () {
        var $this = $(this);
        var propKey = $this.attr(ACCESS_HTML);
        var value = _.get(state,propKey);

        if(value != null){
            Render.html($this,value);
        }
    });
};
/**
 * 返回第一个元素后代构建的数据对象,注意禁用的表单控件和有 disabled 类的元素不会构建，
 * 但有 access-include 类的元素一定会构建
 * @param options
 * @returns {{}}
 */
$.fn.trfBuildAccessState  = function (options) {
    options = $.extend(true,{
        //转换值类型，对应[access-type]
        transformType:{
            boolean:function (value) {
                var type = $.type(value);
                if(type==='array'){
                    return value.length>0;
                }else{
                    if(value==='true'){
                        return true;
                    }else if(value==='false'){
                        return false;
                    }else{
                        return !!value;
                    }
                }
            },
            array:function (value) {
                return $.type(value)==='array'? value:[value];
            },
            number:function (value) {
                return +value;
            },
            string:function (value) {
                return ''+value;
            }
        },
        //读取值，对应[access-render]
        Build:{
            html:function ($el) {
                return $el.html();
            },
            text:function ($el) {
                return $el.text();
            },
            model:function ($el) {
                var v = $el.val();
                if(typeof(v)=='string'){
                    return v.trim();
                }
                else{
                    return v;
                }
            }
        }
    },options);
    var state = {};
    var transformType = options.transformType;
    var Build = options.Build;
    var $scope = this.first();
    //表单控件
    var $accessModel = $scope.find('[' +ACCESS_MODEL+']');
    $accessModel.each(function () {
        var tagName = this.tagName.toLowerCase();
        //非表单元素提前返回
        if(!isFormEleReg.test(tagName)) return;

        var $this = $(this);
        var type = ($this.attr('type')||'').toLowerCase();
        var propKey = $this.attr(ACCESS_MODEL);
        var transform = transformType[$this.attr(ACCESS_TYPE)]||_.identity;
        var value = transform(Build.model($this));

        function setValue(value) {
            if(!$this.is('.access-include') && ($this.prop('disabled') || $this.is('.disabled'))){
                return;
            }
            var stateValue = _.get(state,propKey);
            if($.type(stateValue) ==='array'){
                value = [].concat(stateValue,value);
            }
            if(stateValue !== value){
                _.set(state,propKey,value);
            }
        }

        if(type ==='checkbox' || type ==='radio'){
            if($this.prop('checked')){
                if(type ==='checkbox' && $.type(value) !=='array' &&
                    $accessModel.filter('[' +ACCESS_MODEL+'="' +propKey+'"]').length>=2){
                    value = [value];
                }
                setValue(value);
            }
        }else{
            setValue(value);
        }

    });
    //元素的textContent
    $scope.find('[' +ACCESS_TEXT+']').each(function () {
        var $this = $(this);
        var propKey = $this.attr(ACCESS_TEXT);
        var transform = transformType[$this.attr(ACCESS_TYPE)]||_.identity;
        var value = transform(Build.text($this));

        function setValue(value) {
            if($this.is('.disabled')){
                return;
            }
            var stateValue = _.get(state,propKey);
            if(stateValue !== value){
                _.set(state,propKey,value);
            }
        }

        setValue(value);
    });
    //元素的innerHTML
    $scope.find('[' +ACCESS_HTML+']').each(function () {
        var $this = $(this);
        var propKey = $this.attr(ACCESS_HTML);
        var transform = transformType[$this.attr(ACCESS_TYPE)]||_.identity;
        var value = transform(Build.html($this));

        function setValue(value) {
            if(!$this.is('.access-include') && $this.is('.disabled')){
                return;
            }
            var stateValue = _.get(state,propKey);
            if(stateValue !== value){
                _.set(state,propKey,value);
            }
        }

        setValue(value);
    });
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/components/access-state.js
// module id = 186
// module chunks = 0